import { useParams, useNavigate, Link } from "react-router-dom";
import { ArrowLeft, WhatsappLogo } from "@phosphor-icons/react";
import { Seo } from "@/components/Seo";
import { PublicNavbar } from "@/components/public/PublicNavbar";
import { PublicFooter } from "@/components/public/PublicFooter";
import { WhatsAppFab } from "@/components/public/WhatsAppFab";
import { getPost } from "@/data/blog";
import { waLink } from "@/lib/site";

export default function BlogPost() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const post = getPost(slug);

  if (!post) {
    return (
      <div className="bg-background min-h-screen">
        <PublicNavbar />
        <div className="max-w-3xl mx-auto px-6 py-32 text-center">
          <h1 className="font-heading text-2xl font-semibold">Yazı bulunamadı</h1>
          <Link to="/blog" className="text-brand font-medium mt-4 inline-block">← Blog'a dön</Link>
        </div>
        <PublicFooter />
      </div>
    );
  }

  const jsonLd = {
    "@context": "https://schema.org", "@type": "Article",
    headline: post.title, datePublished: post.date, description: post.excerpt,
    author: { "@type": "Organization", name: "AI Marka Radar" },
  };

  return (
    <div className="bg-background min-h-screen">
      <Seo title={`${post.title} — AI Marka Radar`} description={post.excerpt} path={`/blog/${post.slug}`} jsonLd={jsonLd} />
      <PublicNavbar />
      <WhatsAppFab />
      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
        <button onClick={() => navigate("/blog")} className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-brand mb-8">
          <ArrowLeft size={16} /> Tüm yazılar
        </button>
        <p className="font-mono text-xs text-muted-foreground">{post.date} · {post.readingTime}</p>
        <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.1] mt-3">{post.title}</h1>
        <div className="mt-10 space-y-5">
          {post.body.map((b, i) => {
            if (b.type === "h2") return <h2 key={i} className="font-heading text-2xl font-semibold tracking-tight pt-4">{b.text}</h2>;
            if (b.type === "list") return (
              <ul key={i} className="space-y-2 list-disc pl-5">
                {b.items.map((it, j) => <li key={j} className="text-foreground/85 leading-relaxed">{it}</li>)}
              </ul>
            );
            return <p key={i} className="text-foreground/85 leading-relaxed text-[17px]">{b.text}</p>;
          })}
        </div>
        <div className="border border-border bg-muted p-6 mt-12 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div>
            <p className="font-heading font-semibold text-lg">Markanız yapay zekâda görünüyor mu?</p>
            <p className="text-muted-foreground text-sm">Ücretsiz ilk raporunuzla hemen öğrenin.</p>
          </div>
          <div className="flex gap-2 shrink-0">
            <button onClick={() => navigate("/login")} className="bg-brand text-white font-medium px-5 py-2.5">Ücretsiz Başla</button>
            <a href={waLink()} target="_blank" rel="noreferrer" className="flex items-center gap-2 border border-border px-4 py-2.5 font-medium">
              <WhatsappLogo size={18} weight="fill" className="text-[#25D366]" />
            </a>
          </div>
        </div>
      </article>
      <PublicFooter />
    </div>
  );
}
